const APPEARANCE_FONT_SCALES = ["small", "medium", "large"];

const buildAppearanceDefaults = () => ({
  theme: "light",
  fontScale: "medium",
});

const normalizeAppearancePreferences = (preferences = {}) => {
  const defaults = buildAppearanceDefaults();
  const theme = preferences?.theme === "dark" ? "dark" : defaults.theme;
  const fontScale = APPEARANCE_FONT_SCALES.includes(preferences?.fontScale)
    ? preferences.fontScale
    : defaults.fontScale;
  return { theme, fontScale };
};

const applyAppearancePreferences = (preferences) => {
  if (typeof document === "undefined") {
    return;
  }
  const { theme, fontScale } = normalizeAppearancePreferences(preferences);
  const root = document.documentElement;
  if (!root) {
    return;
  }
  root.dataset.adminTheme = theme;
  root.dataset.adminFontScale = fontScale;
};

const STORAGE_KEY = "adminAppearancePreferences";

const loadStoredAppearancePreferences = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return buildAppearanceDefaults();
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return buildAppearanceDefaults();
    }
    const parsed = JSON.parse(raw);
    return normalizeAppearancePreferences(parsed);
  } catch (error) {
    console.error("Unable to parse stored appearance preferences", error);
    return buildAppearanceDefaults();
  }
};

const saveAppearancePreferences = (preferences) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }
  try {
    const normalized = normalizeAppearancePreferences(preferences);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  } catch (error) {
    console.error("Unable to persist appearance preferences", error);
  }
};

export {
  APPEARANCE_FONT_SCALES,
  applyAppearancePreferences,
  buildAppearanceDefaults,
  loadStoredAppearancePreferences,
  normalizeAppearancePreferences,
  saveAppearancePreferences,
};
